<script lang="ts" setup>
const questionsPage = ref<number>(1);
const isQuestionsLoading = ref(false);
const feedbackStore = useFeedbackStore();
const { selectedOffer } = storeToRefs(useCatalogStore());
const { questions, questionsPagination } = storeToRefs(feedbackStore);
const { isMobile } = useBreakpoints();

await feedbackStore.getQuestions(selectedOffer.value.product_id);

async function loadMoreQuestions() {
  isQuestionsLoading.value = true;
  await feedbackStore.loadMoreQuestions(selectedOffer.value.product_id, ++questionsPage.value);
  isQuestionsLoading.value = false;
}

const isShowAddQuestionModal = ref(false);
</script>

<template>
  <div
    id="questions"
    class="pt-4 text-sm scroll-m-16 lg:scroll-m-52"
  >
    Вам ответит наш консультант или пользователи, купившие этот товар.

    <ClientOnly>
      <TheBtn
        v-if="isMobile"
        class="w-full mt-2"
        color="outline"
        size="sm"
        @click="isShowAddQuestionModal = true"
      >
        Задать свой вопрос
      </TheBtn>

      <ProductPageAddQuestionForm v-else />

      <ProductPageAddQuestionModal v-model="isShowAddQuestionModal" />
    </ClientOnly>

    <div
      v-for="(question, key) in questions"
      :key="question.id"
    >
      <div
        v-if="key !== 0"
        class="border border-black-10"
      />

      <ProductPageQuestionsListItem :question />
    </div>

    <div class="flex justify-center">
      <TheBtn
        v-if="questionsPagination && questions.length < questionsPagination.total"
        :is-loading="isQuestionsLoading"
        class="w-fit mt-4"
        @click="loadMoreQuestions"
      >
        Показать еще
      </TheBtn>
    </div>

    <div
      v-if="!questions.length"
      class="mt-5"
    >
      Пока нет вопросов
    </div>
  </div>
</template>
